import {
  isSmothZoom,
  app,
  settings,
  setHotspotArray,
  imgWidth,
  imgHeight
} from "./variable";

export const initStyles = () => {
  let child;
  if (isSmothZoom) {
    child = document.createElement("img");
  } else {
    child = document.createElement("div");
  }
  const canvas = document.createElement("canvas");
  canvas.classList.add("canvas");
  child.id = "image";
  app.appendChild(child);
  app.appendChild(canvas);
  // check if autorotation and fullscreen are available if not don't show them
  if (!settings.animation_settings.fullscreen) {
    const fullcreenIcon = document.querySelector("#fullScreen");
    if (fullcreenIcon.childNodes.length > 0) app.removeChild(fullcreenIcon);
  }
  if (settings.animation_settings.auto_rotate != "on") {
    const autorotationIcon = document.querySelector("#autorotation");
    if (autorotationIcon.childNodes.length > 0) app.removeChild(autorotationIcon);
  }

  //add image to the buttons
  let buttons = document.querySelectorAll(".button");
  buttons.forEach((btn) => {
    btn.style.backgroundImage = `url(assets/${settings.animation_settings.buttons_img})`;
  });

  const image = document.querySelector("#image");
  let buttonMenu = document.querySelector(".buttons");
  const imageWidth = (((imgWidth / imgHeight) * window.innerHeight) / window.innerWidth * 100).toFixed(2);
  image.style.width = imageWidth + "%";
  image.style.left = (100 - imageWidth) / 2 + "%";
  buttonMenu.style.left = (window.innerWidth / 2 - 150) + "px";
  canvas.style.width = imageWidth + "%";
  canvas.style.left = (100 - imageWidth) / 2 + "%";


  // create metadata as author, keworad and page title
  const keword = document.createElement("meta");
  const author = document.createElement("meta");
  const head = document.querySelector("head");
  keword.name = "keywords";
  keword.content = settings.metadata.keywords;
  head.appendChild(keword);
  author.name = "author";
  author.content = settings.metadata.author;
  head.appendChild(author);
  document.title = settings.metadata.project_title;

  //create hostpots
  let hostpots = [];
  settings.hotspots.forEach((item) => {
    let button = document.createElement("button");
    button.classList.add("hotspot");
    button.style.userSelect = "none";
    button.style.backgroundImage = `url(assets/${settings.animation_settings.buttons_img})`;
    button.style.left = `calc(${item.x * imageWidth / 100 + (100 - imageWidth)/2}% - 16px)`;
    button.style.top = `calc(${item.y}% - 16px)`;

    button.style.setProperty("--tooltip-display", "none");
    button.style.setProperty("--tooltip-font-family", item.text_font);
    button.style.setProperty("--tooltip-content", `"${item.tooltip_text}"`);
    button.style.setProperty("--tooltip-text-color", item.tooltip_text_color);
    button.style.setProperty("--tooltip-bg-color", item.tooltip_bg_color);

    button.onmouseover = () => {
      button.style.setProperty("--tooltip-display", "initial");
    };

    button.onmouseout = () => {
      button.style.setProperty("--tooltip-display", "none");
    };

    button.onclick = () => {
      const dialog = document.querySelector(".backdrop");

      const img = document.querySelector(".img");
      const text = document.querySelector(".text");
      if (item.dialog_img === "") {
        img.src = "";
        text.style.paddingTop = 0;
      } else {
        img.src = "assets/" + item.dialog_img;
        if (item.dialog_text === "") text.style.paddingTop = "10px";
      }

      text.innerHTML = item.dialog_text;
      dialog.style.setProperty("--dialog-display", "flex");
      dialog.style.setProperty("--dialog-font-family", item.text_font);
      dialog.style.setProperty("--dialog-bg-color", item.dialog_bg_color);
      dialog.style.setProperty("--dialog-text-color", item.dialog_text_color);
      dialog.style.setProperty("--dialog-font-family", item.text_font);
      dialog.style.setProperty(
        "--dialog-font-size",
        `${item.text_pixel_size}px`
      );
    };
    hostpots.push({
      name: `${item.row}${item.col}`,
      el: button
    });
  });
  // set dialog off
  const dialog = document.querySelector(".backdrop");
  dialog.style.setProperty("--dialog-display", "none");

  setHotspotArray(hostpots);
};

export const exit = () => {
  const dialog = document.querySelector(".backdrop");
  dialog.style.setProperty("--dialog-display", "none");
};

export const stickWithRigthAspectRatio = (isFullScreen) => {
  const image = document.querySelector("#image");
  const buttonMenu = document.querySelector(".buttons");
  const canvas = document.querySelector(".canvas");
  const imageWidth = (((imgWidth / imgHeight) * screen.height) / screen.width * 100).toFixed(2);
  if (isFullScreen) {
    image.style.width = imageWidth + "%";
    canvas.style.width = imageWidth + "%";

    setTimeout(() => {
      image.style.left = (100 - imageWidth) / 2 + "%";
      canvas.style.left = (100 - imageWidth) / 2 + "%";
    }, 50);
  } else {
    image.style.left = (100 - imageWidth) / 2 + "%";
  }
  buttonMenu.style.left = (window.innerWidth / 2 - 150) + "px";
}